import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const FAQ_DATA = [{
  question: 'What is Giga?',
  answer: 'Giga is an AI employee that lives in Slack. It connects to the apps you already use and actually does the work. It drafts the reply, preps the meeting, files the follow-up, and pulls the data. Your day ends with things finished, not suggested.'
}, {
  question: 'Which apps and tools does Giga work with?',
  answer: "Giga ships with connectors for Slack, GitHub, Notion, HubSpot, Salesforce, Linear, Stripe, Zendesk, and more. Giga supports MCP, so any tool with an MCP server slots right in. If something you depend on isn't supported yet, our team scopes custom connectors for enterprise plans."
}, {
  question: 'Does Giga run on my computer?',
  answer: 'No. Giga runs securely in the cloud. It has its own isolated sandbox where it writes code, crunches files, and opens a browser when work lives behind a login. Nothing runs on your local machine.'
}, {
  question: 'How do I stay in control of what Giga does on my behalf?',
  answer: 'You have granular control over every permission. Giga only gets the access you explicitly grant, and you can require human approval for sensitive actions like sending emails or updating production databases.'
}, {
  question: 'Where does my data go? Is Giga safe to use with sensitive work?',
  answer: 'Yes. Giga stores access tokens encrypted at rest and isolated per workspace. Your data is never shared with other customers or used to train shared models. We respect your existing identity provider permissions.'
}, {
  question: 'How much does Giga cost?',
  answer: 'You start with $100 in credits, free. Credits are shared across your whole workspace and are spent on chats, workflows, pulses, computer use and skills. Monthly plans start at $50, and you only subscribe once the free credit runs out.'
}, {
  question: 'Do I need to start a trial or add a card?',
  answer: 'No. There is no trial clock and no card required. The $100 in credits does not expire, so you can take as long as you need to see what Giga is worth to your team before choosing a plan.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [showAll, setShowAll] = useState(false);
  const visibleFaqs = showAll ? FAQ_DATA : FAQ_DATA.slice(0, 5);
  return <div className="w-full text-[#2B211A] font-body relative z-10" id="faq" data-id="element-3222" data-mp="38lracvcwp7n2">
      <div className="max-w-3xl mx-auto" data-id="element-3223" data-mp="33mely66dzsid">
        {/* Questions */}
        <div className="w-full flex flex-col" data-id="element-3224" data-mp="33n7pkya1u1wa">
          <div className="flex flex-col" data-id="element-3225" data-mp="2yms8bvmnca91">
            <AnimatePresence initial={false} data-id="element-3226" data-mp="2ylia96fsn22e">
              {visibleFaqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return <motion.div key={faq.question} initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -20
              }} transition={{
                duration: 0.3,
                delay: index >= 5 ? (index - 5) * 0.05 : 0
              }} className="border-t border-dashed border-neutral-300 overflow-hidden" data-id="element-3227" data-mp="1n8o8w9xahtwl" data-mpi={index}>
                    <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between gap-6 py-6 md:py-8 text-left focus:outline-none group" data-id="element-3228" data-mp="cfx7tkrontop">
                      <span className="font-title font-bold text-xl md:text-2xl text-[#2B211A] leading-snug" data-id="element-3229" data-mp="hhctnf1oq485">
                        {faq.question}
                      </span>
                      <motion.div animate={{
                    rotate: isOpen ? 180 : 0
                  }} transition={{
                    duration: 0.2
                  }} className="shrink-0 text-[#2B211A]" data-id="element-3230" data-mp="qg83d13xtwg7">
                        <ChevronDown className="w-5 h-5" strokeWidth={1.5} data-id="element-3231" data-mp="2s95v0tlzaizk" />
                      </motion.div>
                    </button>
                    <AnimatePresence initial={false} data-id="element-3232" data-mp="21vga089fsbmd">
                      {isOpen && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.3,
                    ease: 'easeInOut'
                  }} data-id="element-3233" data-mp="21xsuas2o2y2l">
                          <div className="pb-8 pt-0 text-neutral-600 leading-relaxed text-base md:text-lg max-w-3xl" data-id="element-3234" data-mp="1e6x2huy7o2vc">
                            {faq.answer}
                          </div>
                        </motion.div>}
                    </AnimatePresence>
                  </motion.div>;
            })}
            </AnimatePresence>
            {/* Bottom border for the last item */}
            <div className="border-t border-dashed border-neutral-300" data-id="element-3235" data-mp="vg5lq8bw9a6x" />
          </div>

          {!showAll && FAQ_DATA.length > 5 && <div className="flex justify-start mt-8" data-id="element-3236" data-mp="3727u3hv5zmi2">
              <button onClick={() => setShowAll(true)} className="text-sm font-medium text-[#2B211A] hover:text-[#EA580C] transition-colors flex items-center gap-1" data-id="element-3237" data-mp="371fwk1i0bep5">
                Read more FAQs <ChevronDown size={14} data-id="element-3238" data-mp="2x6waal4wfp3g" />
              </button>
            </div>}
        </div>
      </div>
    </div>;
}